import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import WelcomePopoverContainer from './WelcomePopoverContainer';

const useStyles = makeStyles()((theme) => ({
  popup: {
    position: 'absolute',
    top: 82,
    zIndex: 300,
    right: 'calc((100vw - 288px) / 2)',
    [theme.breakpoints.up('sm')]: {
      right: 40,
      '&::before': {
        color: '#3753D7',
        top: -24,
        right: 24,
        content: '"▲"',
        fontSize: 24,
        position: 'absolute',
        width: 24,
        height: 22,
      },
    },
  },
}));

interface IProps {
  onClose: any;
  onOpenModal?: any;
}

const WelcomePopover: React.FC<React.PropsWithChildren<IProps>> = (props) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.popup}>
      <WelcomePopoverContainer {...props} />
    </Box>
  );
};

export default WelcomePopover;
